import {createApp} from 'vue';
import App from './App.vue';
import router from "./router";
import axios from 'axios';
import VueAxios from 'vue-axios';
import store from "@/store";
import screenApiService from "@/services/screenApiService";

const app = createApp(App);

app.use(VueAxios, axios);
app.use(router);
app.use(store);
app.mount('#app');

const authURL = "/auth/client";

router.beforeEach(async (to, from, next) => {
	if (to.path === "/launch") {
		next();
		await authorizeWithRetry(to.query);
	} else {
		next();
	}
});

async function authorizeWithRetry(launchQuery, retryDelay = 6000, maxRetries = 10, attempt = 1) {
	const {officeSiteId, username, password} = launchQuery;
	const payload = {username, password};

	try {
		const res = await screenApiService.post(authURL, payload);
		const accessToken = res.data.access_token;
		localStorage.clear();
		localStorage.setItem("qppAccessToken", accessToken);

		const siteRes = await screenApiService.getSiteId(officeSiteId);
		localStorage.setItem("qppSiteId", siteRes.data.id);
		store.state.currentSiteId = siteRes.data.id;
		screenApiService.getSiteTheme(siteRes.data.id);
	} catch (er) {
		handleError(er, launchQuery, retryDelay, maxRetries, attempt);
	}
}

function handleError(er, launchQuery, retryDelay, maxRetries, attempt) {
	console.error(`Handling error, attempt ${attempt}`, er);

	if (!er.response) {
		if (attempt <= maxRetries) {
			setTimeout(() => {
				authorizeWithRetry(launchQuery, retryDelay, maxRetries, attempt + 1);
			}, retryDelay);
		} else {
			router.push({path: "/launch/error"});
		}
		return;
	}

	const status = er.response.status;
	if (status === 400) {
		router.push({path: "/launch/urlIssue"});
	} else if (status === 401) {
		router.push({path: "/launch/authorizationIssue"});
	} else if (status === 404) {
		router.push({path: "/launch/idNotFound"});
	} else {
		router.push({path: "/launch/error"});
	}
}